import { type SelectProps } from 'antd';
import { Select } from '@shared/ui/antd';
import { type FC } from 'react';
import { type ChannelTypeEnum, useGetChannelListChannelListGetQuery } from '@shared/api';
import { authSelectors } from '@shared/redux/ducks/auth';
import { useAppSelector } from '@shared/redux';

interface InfinitySelectorChannelsProps extends SelectProps {
  selectMode?: 'tags' | 'multiple' | 'undefined';
  placeholderLastPage?: string;
  isSingleSelectMode?: boolean;
  isDisabled?: boolean;
  maxLabelLength?: number;
  uppercase?: boolean;
  channelTypes?: ChannelTypeEnum[];
}

export const InfinitySelectorChannels: FC<InfinitySelectorChannelsProps> = ({
  maxLabelLength,
  uppercase,
  channelTypes,
  ...props
}) => {
  const currentOrganization = useAppSelector(authSelectors.selectCurrentOrganizationInfo);

  const { data, isLoading, refetch } = useGetChannelListChannelListGetQuery({
    organizationId: currentOrganization.id,
  });

  const truncateLabel = (value: string | number) => {
    if (!maxLabelLength || maxLabelLength <= 0) return value;
    const str = String(value ?? '');
    const maybeUpper = uppercase ? str.toUpperCase() : str;
    return maybeUpper.length > maxLabelLength
      ? `${maybeUpper.slice(0, maxLabelLength)}…`
      : maybeUpper;
  };

  const options = data
    ?.filter((item) => !channelTypes || channelTypes.includes(item.type))
    .map((item) => ({
      label: truncateLabel(item.name),
      value: item.id,
    }));

  return (
    <Select
      {...props}
      options={options}
      loading={isLoading}
      onChange={(value, option) => {
        props.onChange?.(value, option);
      }}
      isSingleSelectMode={props.isSingleSelectMode}
      isDisabled={props.isDisabled}
      onDropdownVisibleChange={(open) => {
        if (open) {
          refetch();
        }
      }}
    />
  );
};
